import { mulQ4 } from "./arith";
import { DomainError } from "./errors";

const Q4 = 10_000n;

export type KitComponentStock = {
  /** Quantidade do componente em um kit (q4, > 0). */
  qtyQ4: number;
  /** Disponível do componente (físico − reservado, q4). */
  availableQ4: number;
  /** Componente sem controle de estoque (serviço, por exemplo) não limita o kit. */
  stockControl: boolean;
};

function assertInt(v: number, what: string) {
  if (!Number.isSafeInteger(v)) throw new DomainError("not_integer", `${what} deve ser inteiro: ${v}`);
}

/**
 * Disponível do kit (formato E), que não tem saldo próprio (05 §5): `min(floor(available(c) / qty(c)))` em kits
 * inteiros, devolvido em q4. Saldo zero ou negativo dá zero. Sem componente controlado, o kit é ilimitado (null).
 */
export function kitAvailableQ4(components: KitComponentStock[]): number | null {
  let min: bigint | null = null;
  for (const c of components) {
    assertInt(c.qtyQ4, "quantidade");
    assertInt(c.availableQ4, "disponível");
    if (c.qtyQ4 <= 0)
      throw new DomainError("invalid_qty", `quantidade do componente deve ser positiva: ${c.qtyQ4}`);
    if (!c.stockControl) continue;
    const kits = c.availableQ4 <= 0 ? 0n : BigInt(c.availableQ4) / BigInt(c.qtyQ4);
    if (min === null || kits < min) min = kits;
  }
  if (min === null) return null;
  const q4 = Number(min * Q4);
  if (!Number.isSafeInteger(q4)) throw new DomainError("invalid_qty", "disponível do kit fora do limite");
  return q4;
}

/** Custo dos componentes de um kit: Σ custo unitário × quantidade (centavos, arredondamento comercial por linha). */
export function kitCostCents(components: { qtyQ4: number; unitCostCents: number }[]): number {
  let total = 0;
  for (const c of components) total += mulQ4(c.unitCostCents, c.qtyQ4);
  if (!Number.isSafeInteger(total)) throw new DomainError("invalid_money", "custo do kit fora do limite");
  return total;
}

/** Soma de quantidades q4 (o pai de variação mostra a soma dos filhos). */
export function sumQ4(values: number[]): number {
  let total = 0n;
  for (const v of values) {
    assertInt(v, "quantidade");
    total += BigInt(v);
  }
  const n = Number(total);
  if (!Number.isSafeInteger(n)) throw new DomainError("invalid_qty", "soma de quantidades fora do limite");
  return n;
}
